import React, { useState, useEffect, useContext } from 'react';
import './RolesPage.css';
import { CrudRoles } from '../../Components/Cruds/CrudRoles';
import { CrudModules } from '../../Components/Cruds/CrudModules';
import { getUserPermissionsByUserEmail } from '../../api/usersModule/getters';
import { NotFoundPage } from '../NotFoundPage/NotFoundPage';
import { LoadingPage } from '../LoadingPage/LoadingPage';
import UserContext from '../../utils/Contexts/UserContext';

const moduleName = 'Modulos y Roles';
export const RolesPage = () => {
	const [userPermissions, setUserPermissions] = useState([]);
	const [loading, setLoading] = useState(true);
	const user = useContext(UserContext);

	const getPermissions = async () => {
		setLoading(true);

		let permissions = {
			Consultar: false,
			Crear: false,
			Editar: false,
			Eliminar: false,
		};

		try {
			permissions = await getUserPermissionsByUserEmail(
				user.attributes['email'],
				user.attributes['custom:project'],
				moduleName
			);
			try {
				permissions['Consultar']
					? setUserPermissions(permissions)
					: setUserPermissions([]);
			} catch (error) {
				permissions['Consultar'] = false;
			}
			setUserPermissions(permissions);
			setLoading(false);
		} catch (error) {
			setLoading(false);
		}
	};

	useEffect(() => {
		getPermissions();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			{userPermissions['Consultar'] ? (
				<div
					style={{
						flex: '1 1 auto',
						display: 'flex',
						flexFlow: 'column',
						height: '100vh',
						overflowY: 'auto',
					}}
				>
					<div
						style={{
							padding: '20px 5%',
						}}
					>
						<CrudModules
							userName={user.attributes['family_name']}
							permissions={userPermissions}
							project={user.attributes['custom:project']}
						/>
					</div>
					<div
						style={{
							padding: '20px 5%',
							height: '50%',
						}}
					>
						<CrudRoles
							userName={user.attributes['family_name']}
							permissions={userPermissions}
							project={user.attributes['custom:project']}
						/>
					</div>
				</div>
			) : loading ? (
				<LoadingPage />
			) : (
				<NotFoundPage />
			)}
		</>
	);
};
